//export const API = "http://192.168.0.103:3103";
export const API = "https://mica.infosistemweb.com";
// export const API = 'https://aplikacije-api.infosistemweb.com';
// export const API = 'http://testreactapi.infosistemweb.com';
//  export const API = 'http://testfinansijeapi.infosistemweb.com';
/* export const API = "http://finansije1api.infosistemweb.com"; */
